import React, { useEffect } from 'react';
import './TongQuan.css'

function TongQuan () {

  useEffect(() => {

    // đợi leaflet load
    if (!window.L) return;

    const L = window.L;

    // tránh map bị render nhiều lần
    if (window.dashboardMapInstance) {
      window.dashboardMapInstance.remove();
    }

    // ===== TẠO MAP =====

    const map = L.map("dashboardMap", {
      zoomControl: false
    }).setView([10.5216, 105.1259], 9);

    window.dashboardMapInstance = map;

    // ===== TILE MAP =====

    L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        attribution: "&copy; OpenStreetMap contributors"
      }
    ).addTo(map);

    // ===== ZOOM CONTROL =====

    L.control.zoom({
      position: "bottomleft"
    }).addTo(map);

    // ===== CUSTOM ICON =====

    const industrialIcon = L.divIcon({
      html: `
        <div class="custom-map-marker">
          <i class="fas fa-industry"></i>
        </div>
      `,
      className: "",
      iconSize: [40, 40],
      iconAnchor: [20, 20]
    });

    // ===== 6 KHU CÔNG NGHIỆP =====

    const locations = [

      {
        name: "KCN Bình Hòa",
        area: "318 ha",
        coords: [10.6437, 105.012]
      },

      {
        name: "KCN Bình Hòa 2",
        area: "250 ha",
        coords: [10.598, 105.15]
      },

      {
        name: "KCN Vàm Cống",
        area: "1.480 ha",
        coords: [10.400, 105.470]
      },

      {
        name: "KCN Thoại Sơn",
        area: "247 ha",
        coords: [10.274, 105.290]
      },

      {
        name: "KCN Hội An",
        area: "296 ha",
        coords: [10.480, 105.240]
      },

      {
        name: "KCN Vĩnh Thạnh Trung",
        area: "410 ha",
        coords: [10.780, 105.250]
      }

    ];

    locations.forEach((item) => {

      L.marker(item.coords, {
        icon: industrialIcon
      })
        .addTo(map)
        .bindPopup(`
          <div class="map-popup">
            <b>${item.name}</b>
            <br/>
            ${item.area}
          </div>
        `);

    });

    // ===== VẼ RANH GIỚI AN GIANG =====

    const anGiangBorder = [

      [10.940, 104.780],
      [10.920, 105.030],
      [10.840, 105.240],
      [10.780, 105.420],
      [10.620, 105.520],
      [10.420, 105.540],
      [10.230, 105.430],
      [10.090, 105.260],
      [10.120, 104.980],
      [10.240, 104.790],
      [10.450, 104.720],
      [10.700, 104.700],
      [10.940, 104.780]

    ];

    L.polygon(anGiangBorder, {
      color: "#5d56ff",
      fillColor: "#5d56ff",
      fillOpacity: 0.05,
      weight: 3
    }).addTo(map);

  }, []);

   
        return (
        <div className=" dashboard-wrapper">
  <div className="dashboard-container">

    {/* <!-- TOP CARD --> */}
    <div className="dashboard-card-row">

      <div className="dashboard-card dashboard-card-purple">
        <div className="dashboard-card-icon dashboard-card-icon-purple">
          <i className="fas fa-chart-line"></i>
        </div>

        <div className="dashboard-card-content">
          <p className="dashboard-card-title">Khu công nghiệp</p>
          <h2 className="dashboard-card-number">08 <span className="dashboard-card-unit">KCN</span></h2>
          <p className="dashboard-card-desc">Tổng diện tích 3.251 ha</p>
        </div>
      </div>

      <div className="dashboard-card dashboard-card-green">
        <div className="dashboard-card-icon dashboard-card-icon-green">
          <i className="fas fa-building"></i>
        </div>

        <div className="dashboard-card-content">
          <p className="dashboard-card-title">Doanh nghiệp</p>
          <h2 className="dashboard-card-number">356 <span className="dashboard-card-unit">doanh nghiệp</span></h2>
          <p className="dashboard-card-desc">Đang hoạt động 298 DN</p>
        </div>
      </div>

      <div className="dashboard-card dashboard-card-violet">
        <div className="dashboard-card-icon dashboard-card-icon-violet">
          <i className="fas fa-chart-bar"></i>
        </div>

        <div className="dashboard-card-content">
          <p className="dashboard-card-title">Vốn đầu tư</p>
          <h2 className="dashboard-card-number">96.245 <span className="dashboard-card-unit">tỷ đồng</span></h2>
          <p className="dashboard-card-desc">Tổng vốn đăng ký</p>
        </div>
      </div>

      <div className="dashboard-card dashboard-card-yellow">
        <div className="dashboard-card-icon dashboard-card-icon-yellow">
          <i className="fas fa-users"></i>
        </div>

        <div className="dashboard-card-content">
          <p className="dashboard-card-title">Lao động</p>
          <h2 className="dashboard-card-number">134.567 <span className="dashboard-card-unit">người</span></h2>
          <p className="dashboard-card-desc">Tổng số lao động</p>
        </div>
      </div>

      <div className="dashboard-card dashboard-card-cyan">
        <div className="dashboard-card-icon dashboard-card-icon-cyan">
          <i className="fas fa-leaf"></i>
        </div>

        <div className="dashboard-card-content">
          <p className="dashboard-card-title">Dự án đầu tư</p>
          <h2 className="dashboard-card-number">512 <span className="dashboard-card-unit">dự án</span></h2>
          <p className="dashboard-card-desc">Đang triển khai 186 dự án</p>
        </div>
      </div>

    </div>
{/* 
    <!-- MAP + CHART --> */}
    <div className="dashboard-middle-row">

      {/* <!-- MAP --> */}
      <div className="dashboard-map-box">

        <div className="dashboard-box-header">
          <h3 className="dashboard-box-title">Bản đồ khu công nghiệp</h3>

          <a href="#" className="dashboard-box-link">
            Xem chi tiết
            <i className="fas fa-angle-right icon-angel-right"></i>
          </a>
        </div>

        <div className="dashboard-map-content">

          <div className="dashboard-map-image">
            <div id="dashboardMap"></div>
     {/* <iframe
    title="map"
    className="dashboard-map-frame"
    src="https://www.openstreetmap.org/export/embed.html?bbox=104.5%2C9.8%2C106.9%2C11.8&layer=mapnik"
  ></iframe>

 
  <div className="map-region map-region-1"></div>

 
  <div className="map-region map-region-2"></div>

  
  <div className="map-region map-region-3"></div>

  
  <div className="map-region map-region-4"></div>

  
  <div className="map-region map-region-5"></div>

 
  <div className="map-region map-region-6"></div> */}

  {/* Marker */}
  <div className="map-marker marker-1">
    <i className="fa-solid fa-industry"></i>
  </div>

  <div className="map-marker marker-2">
    <i className="fa-solid fa-industry"></i>
  </div>

  <div className="map-marker marker-3">
    <i className="fa-solid fa-industry"></i>
  </div>

  <div className="dashboard-map-control dashboard-map-plus">
    +
  </div>

  <div className="dashboard-map-control dashboard-map-minus">
    -
  </div>

  <div className="dashboard-map-control dashboard-map-location">
    <i className="fas fa-location-arrow"></i>
  </div>

            {/* <div className="dashboard-map-control dashboard-map-plus">
              +
            </div>

            <div className="dashboard-map-control dashboard-map-minus">
              -
            </div>

            <div className="dashboard-map-control dashboard-map-location">
              <i className="fas fa-location-arrow"></i>
            </div> */}
          </div>

          <div className="dashboard-map-list">

            <div className="dashboard-map-item">
              <span className="dashboard-map-dot"></span>
              <div className="dashboard-map-text">
                <p className="dashboard-map-name">KCN Bình Hòa</p>
                <span className="dashboard-map-area">318 ha</span>
              </div>
            </div>

            <div className="dashboard-map-item">
              <span className="dashboard-map-dot"></span>
              <div className="dashboard-map-text">
                <p className="dashboard-map-name">KCN Bình Hòa 2</p>
                <span className="dashboard-map-area">250 ha</span>
              </div>
            </div>

            <div className="dashboard-map-item">
              <span className="dashboard-map-dot"></span>
              <div className="dashboard-map-text">
                <p className="dashboard-map-name">KCN Vàm Cống</p>
                <span className="dashboard-map-area">1.480 ha</span>
              </div>
            </div>

            <div className="dashboard-map-item">
              <span className="dashboard-map-dot"></span>
              <div className="dashboard-map-text">
                <p className="dashboard-map-name">KCN Thoại Sơn</p>
                <span className="dashboard-map-area">247 ha</span>
              </div>
            </div>

            <div className="dashboard-map-item">
              <span className="dashboard-map-dot"></span>
              <div className="dashboard-map-text">
                <p className="dashboard-map-name">KCN Hội An</p>
                <span className="dashboard-map-area">296 ha</span>
              </div>
            </div>

            <div className="dashboard-map-item">
              <span className="dashboard-map-dot"></span>
              <div className="dashboard-map-text">
                <p className="dashboard-map-name">KCN Bình Long</p>
                <span className="dashboard-map-area">-- ha</span>
              </div>
            </div>

            <div className="dashboard-map-item">
              <span className="dashboard-map-dot"></span>
              <div className="dashboard-map-text">
                <p className="dashboard-map-name">KCN Vĩnh Thạnh Trung</p>
                <span className="dashboard-map-area">410 ha</span>
              </div>
            </div>

            <div className="dashboard-map-item">
              <span className="dashboard-map-dot"></span>
              <div className="dashboard-map-text">
                <p className="dashboard-map-name">KCN Tân Châu</p>
                <span className="dashboard-map-area">-- ha</span>
              </div>
            </div>

          </div>

        </div>

      </div>

      {/* <!-- CHART --> */}
      <div className="dashboard-chart-box">

        <div className="dashboard-box-header">
          <h3 className="dashboard-box-title">Tình hình thu hút đầu tư</h3>

          <div className="dashboard-chart-year">
            Năm 2026
            <i className="fas fa-angle-down icon-angel-right"></i>
          </div>
        </div>

        <div className="dashboard-chart-top">

          <div className="dashboard-chart-info">
            <p className="dashboard-chart-info-title">Vốn đăng ký</p>
            <h3 className="dashboard-chart-info-number">12.245</h3>
            <span className="dashboard-chart-info-unit">tỷ đồng</span>
            <p className="dashboard-chart-info-growth dashboard-growth-green">
              ↑ 18,6% so với cùng kỳ
            </p>
          </div>

          <div className="dashboard-chart-info">
            <p className="dashboard-chart-info-title">Vốn thực hiện</p>
            <h3 className="dashboard-chart-info-number">5.642</h3>
            <span className="dashboard-chart-info-unit">tỷ đồng</span>
            <p className="dashboard-chart-info-growth dashboard-growth-green">
              ↑ 12,3% so với cùng kỳ
            </p>
          </div>

          <div className="dashboard-chart-info">
            <p className="dashboard-chart-info-title">Số dự án mới</p>
            <h3 className="dashboard-chart-info-number">46</h3>
            <span className="dashboard-chart-info-unit">dự án</span>
            <p className="dashboard-chart-info-growth dashboard-growth-green">
              ↑ 21,1% so với cùng kỳ
            </p>
          </div>

          <div className="dashboard-chart-info">
            <p className="dashboard-chart-info-title">Dự án điều chỉnh</p>
            <h3 className="dashboard-chart-info-number">28</h3>
            <span className="dashboard-chart-info-unit">dự án</span>
            <p className="dashboard-chart-info-growth dashboard-growth-red">
              ↓ 5,4% so với cùng kỳ
            </p>
          </div>

        </div>

        {/* <!-- CHART --> */}
        <div className="dashboard-chart-wrapper">

          <div className="dashboard-chart-y-axis">
            <span>15,000</span>
            <span>12,000</span>
            <span>9,000</span>
            <span>6,000</span>
            <span>3,000</span>
            <span>0</span>
          </div>

          <div className="dashboard-chart-content">

            {/* <!-- horizontal --> */}
            <div className="dashboard-chart-line dashboard-chart-line-1"></div>
            <div className="dashboard-chart-line dashboard-chart-line-2"></div>
            <div className="dashboard-chart-line dashboard-chart-line-3"></div>
            <div className="dashboard-chart-line dashboard-chart-line-4"></div>
            <div className="dashboard-chart-line dashboard-chart-line-5"></div>
            <div className="dashboard-chart-line dashboard-chart-line-6"></div>
{/* 
            <!-- BLUE --> */}
            <div className="dashboard-chart-blue">
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-1"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-2"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-3"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-4"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-5"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-6"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-7"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-8"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-9"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-10"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-11"></span>
              <span className="dashboard-chart-dot dashboard-chart-blue-dot-12"></span>

              <svg className="dashboard-chart-svg">
                <polyline
                  points="
                  20,180
                  70,145
                  120,135
                  170,110
                  220,100
                  270,92
                  320,60
                  370,40
                  420,25
                  470,18
                  520,5
                  "
                  fill="none"
                  stroke="#4b45ff"
                  strokeWidth="3"
                />
              </svg>
            </div>

            {/* <!-- GREEN --> */}
            <div className="dashboard-chart-green">
              <span className="dashboard-chart-dot dashboard-chart-green-dot-1"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-2"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-3"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-4"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-5"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-6"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-7"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-8"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-9"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-10"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-11"></span>
              <span className="dashboard-chart-dot dashboard-chart-green-dot-12"></span>

              <svg className="dashboard-chart-svg">
                <polyline
                  points="
                  20,200
                  70,185
                  120,175
                  170,155
                  220,145
                  270,135
                  320,110
                  370,92
                  420,80
                  470,70
                  520,55
                  "
                  fill="none"
                  stroke="#23b26d"
                  strokeWidth="3"
                />
              </svg>
            </div>

            <div className="dashboard-chart-months">
              <span>T01</span>
              <span>T02</span>
              <span>T03</span>
              <span>T04</span>
              <span>T05</span>
              <span>T06</span>
              <span>T07</span>
              <span>T08</span>
              <span>T09</span>
              <span>T10</span>
              <span>T11</span>
              <span>T12</span>
            </div>

          </div>

        </div>

        <div className="dashboard-chart-legend">
          <div className="dashboard-chart-legend-item">
            <span className="dashboard-chart-legend-blue"></span>
            <p>Vốn đăng ký</p>
          </div>

          <div className="dashboard-chart-legend-item">
            <span className="dashboard-chart-legend-green"></span>
            <p>Vốn thực hiện</p>
          </div>
        </div>

      </div>

    </div>

    {/* <!-- BOTTOM --> */}
    <div className="dashboard-bottom-row">

      {/* <!-- RATE --> */}
      <div className="dashboard-rate-box">

        <div className="dashboard-box-header">
          <h3 className="dashboard-box-title">Tỷ lệ lấp đầy khu công nghiệp</h3>

          <a href="#" className="dashboard-box-link">
            Xem chi tiết
            <i className="fas fa-angle-right icon-angel-right"></i>
          </a>
        </div>

        <div className="dashboard-rate-list">

          <div className="dashboard-rate-item">
            <span className="dashboard-rate-name">KCN Bình Hòa</span>

            <div className="dashboard-rate-bar">
              <div className="dashboard-rate-fill dashboard-rate-fill-85"></div>
            </div>

            <span className="dashboard-rate-percent">85%</span>
          </div>

          <div className="dashboard-rate-item">
            <span className="dashboard-rate-name">KCN Bình Hòa 2</span>

            <div className="dashboard-rate-bar">
              <div className="dashboard-rate-fill-blue dashboard-rate-fill-79"></div>
            </div>

            <span className="dashboard-rate-percent">79%</span>
          </div>

          <div className="dashboard-rate-item">
            <span className="dashboard-rate-name">KCN Vàm Cống</span>

            <div className="dashboard-rate-bar">
              <div className="dashboard-rate-fill dashboard-rate-fill-83"></div>
            </div>

            <span className="dashboard-rate-percent">83%</span>
          </div>

          <div className="dashboard-rate-item">
            <span className="dashboard-rate-name">KCN Thoại Sơn</span>

            <div className="dashboard-rate-bar">
              <div className="dashboard-rate-fill-blue dashboard-rate-fill-72"></div>
            </div>

            <span className="dashboard-rate-percent">72%</span>
          </div>

          <div className="dashboard-rate-item">
            <span className="dashboard-rate-name">KCN Hội An</span>

            <div className="dashboard-rate-bar">
              <div className="dashboard-rate-fill dashboard-rate-fill-65"></div>
            </div>

            <span className="dashboard-rate-percent">65%</span>
          </div>

          <div className="dashboard-rate-item">
            <span className="dashboard-rate-name">KCN Bình Long</span>

            <div className="dashboard-rate-bar">
              <div className="dashboard-rate-fill-blue dashboard-rate-fill-68"></div>
            </div>

            <span className="dashboard-rate-percent">68%</span>
          </div>

        </div>

      </div>

      {/* <!-- ALERT --> */}
      <div className="dashboard-alert-box">

        <div className="dashboard-box-header">
          <h3 className="dashboard-box-title">Cảnh báo - Thông báo</h3>

          <a href="#" className="dashboard-box-link">
            Xem tất cả
            <i className="fas fa-angle-right icon-angel-right"></i>
          </a>
        </div>

        <div className="dashboard-alert-list">

          <div className="dashboard-alert-item">
            <i className="fas fa-exclamation-triangle dashboard-alert-red"></i>

            <div className="dashboard-alert-content">
              <p className="dashboard-alert-text">
                Cảnh báo chất lượng nước thải tại KCN Bình Hòa
              </p>

              <span className="dashboard-alert-time">
                12/05/2026 - 08:30
              </span>
            </div>
          </div>

          <div className="dashboard-alert-item">
            <i className="fas fa-exclamation-triangle dashboard-alert-yellow"></i>

            <div className="dashboard-alert-content">
              <p className="dashboard-alert-text">
                Sắp hết hạn giấy phép môi trường - KCN Vàm Cống
              </p>

              <span className="dashboard-alert-time">
                12/05/2026 - 07:45
              </span>
            </div>
          </div>

          <div className="dashboard-alert-item">
            <i className="fas fa-info-circle dashboard-alert-blue"></i>

            <div className="dashboard-alert-content">
              <p className="dashboard-alert-text">
                Có 03 doanh nghiệp đề xuất điều chỉnh dự án
              </p>

              <span className="dashboard-alert-time">
                11/05/2026 - 16:20
              </span>
            </div>
          </div>

          <div className="dashboard-alert-item">
            <i className="fas fa-check-circle dashboard-alert-green"></i>

            <div className="dashboard-alert-content">
              <p className="dashboard-alert-text">
                Báo cáo tình hình lao động quý II/2026
              </p>

              <span className="dashboard-alert-time">
                11/05/2026 - 09:15
              </span>
            </div>
          </div>

        </div>

      </div>

      {/* <!-- FILE --> */}
      <div className="dashboard-file-box">

        <div className="dashboard-box-header">
          <h3 className="dashboard-box-title">Tài liệu - Biểu mẫu</h3>

          <a href="#" className="dashboard-box-link">
            Xem tất cả
            <i className="fas fa-angle-right icon-angel-right"></i>
          </a>
        </div>

        <div className="dashboard-file-list">

          <div className="dashboard-file-item">
            <div className="dashboard-file-left">
              <i className="fas fa-file-pdf dashboard-file-red"></i>

              <div className="dashboard-file-content">
                <p className="dashboard-file-name">
                  Báo cáo tình hình hoạt động KCN tháng 04/2026
                </p>

                <span className="dashboard-file-size">
                  PDF - 2.4 MB
                </span>
              </div>
            </div>

            <i className="fas fa-download dashboard-file-download"></i>
          </div>

          <div className="dashboard-file-item">
            <div className="dashboard-file-left">
              <i className="fas fa-file-pdf dashboard-file-blue"></i>

              <div className="dashboard-file-content">
                <p className="dashboard-file-name">
                  Quy hoạch phát triển KCN tỉnh An Giang đến 2030
                </p>

                <span className="dashboard-file-size">
                  PDF - 5.7 MB
                </span>
              </div>
            </div>

            <i className="fas fa-download dashboard-file-download"></i>
          </div>

          <div className="dashboard-file-item">
            <div className="dashboard-file-left">
              <i className="fas fa-file-excel dashboard-file-green"></i>

              <div className="dashboard-file-content">
                <p className="dashboard-file-name">
                  Mẫu báo cáo môi trường định kỳ
                </p>

                <span className="dashboard-file-size">
                  XLSX - 1.1 MB
                </span>
              </div>
            </div>

            <i className="fas fa-download dashboard-file-download"></i>
          </div>

          <div className="dashboard-file-item">
            <div className="dashboard-file-left">
              <i className="fas fa-file-pdf dashboard-file-red"></i>

              <div className="dashboard-file-content">
                <p className="dashboard-file-name">
                  Hướng dẫn thủ tục đầu tư trong KCN
                </p>

                <span className="dashboard-file-size">
                  PDF - 3.2 MB
                </span>
              </div>
            </div>

            <i className="fas fa-download dashboard-file-download"></i>
          </div>

        </div>

      </div>

    </div>

  </div>
</div>
        );
    
}



export default TongQuan;